import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { computed } from 'vue';
import { useInputStore } from '@/features/Sparten';
import {
  hasGapDeckung,
  hasNoDamage,
  hasOneChild,
  hasSeveralChildren,
  isAnhaengerBauartAvailable,
  isAufbauartAvailable,
  isErstbesitzer,
  isFahrerkreisAny,
  isFahrerkreisAvailable,
  isFahrerkreisFix,
  isFahrerkreisNoAgeRestriction,
  isFahrerkreisVNDriver,
  isFahrerschutzversicherungAvailable,
  isHaftpflicht,
  isJaehrlicheFahrleistungAvailable,
  isNoAbweichenderHalter,
  isNoMinors,
  isNoSaisonkennzeichen,
  isNotAnAdditionalCar,
  isNoTeilkasko,
  isNotGermanOrIsCompany,
  isNotHaftpflichtFeature,
  isNoVollkasko,
  isNoVorversicherung,
  isNutzungsartAvailable,
  isOnlyHaftpflichtFeature,
  isOnlyVollkaskoFeature,
  isRabattschutzKfzHaftpflichtAvailable,
  isRabattschutzKfzVollkaskoAvailable,
  isSfKlasseAvailable,
  isVnVorsteuerabzugsberechtigt,
  temporaryField,
} from '@/features/Sparten/shared/inputDehydration/kfz/conditionalRequestDefinitions';

export const isFirma: ConditionalRequestDefinition = {
  if: computed(() => useInputStore().versicherungsnehmer.isFirma),
  drop: [
    'anredeId',
    'geburtsdatum',
    'familienstand',
    'nationalitaet',
    'versicherungsnehmer.berufsstatus',
    'versicherungsnehmer.beruf',
    'versicherungsnehmer.speziellerArbeitgeber',
    'versicherungsnehmer.tarifgruppe',
    'versicherungsnehmer.hasMinderjaehrigeKinder',
    'versicherungsnehmer.minderjaehrigeKinder',
    'versicherungsnehmer.hasFuehrerscheinInEUErworben',
    'versicherungsnehmer.isMitarbeiterAutohersteller',
    'versicherungsnehmer.hasWohnsitzMin5JahreInBrd',
    'versicherungsnehmer.hasPunkteInFlensburg',
    'versicherungsnehmer.isVorsteuerAbzugsberechtigt',
    'versicherungsnehmer.mitgliedschaften',
    'versicherungsnehmer.fuehrerscheindatum',
    'versicherungsnehmer.hasAnSicherheitstrainingTeilgenommen',
  ],
};

export const inputDehydrationDefinitions: ConditionalRequestDefinition[] = [
  isNoAbweichenderHalter,
  isErstbesitzer,
  isFirma,
  isAnhaengerBauartAvailable,
  isAufbauartAvailable,
  isJaehrlicheFahrleistungAvailable,
  isNutzungsartAvailable,
  isFahrerkreisAvailable,
  isSfKlasseAvailable,
  isFahrerschutzversicherungAvailable,
  isRabattschutzKfzHaftpflichtAvailable,
  isRabattschutzKfzVollkaskoAvailable,
  isNotGermanOrIsCompany,
  isFahrerkreisVNDriver,
  isFahrerkreisFix,
  isFahrerkreisAny,
  isFahrerkreisNoAgeRestriction,
  isNoSaisonkennzeichen,
  isNotAnAdditionalCar,
  isNoVollkasko,
  isNoTeilkasko,
  isHaftpflicht,
  isNoMinors,
  isNoVorversicherung,
  hasOneChild,
  hasSeveralChildren,
  hasNoDamage,
  isOnlyHaftpflichtFeature,
  isNotHaftpflichtFeature,
  isOnlyVollkaskoFeature,
  hasGapDeckung,
  isVnVorsteuerabzugsberechtigt,
  temporaryField,
];
